<template>
    <div class="simulator-box m-sm-0 p-sm-0 card-panel ">

        <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : carregando}">Fonte de Renda</h2>

        <div class="flex-row" v-if="cliente">

            <div class="col-lg-5 col-sm-12" v-if="fonteRendaTitular">

                <h3 class="simulator-title subtitle">Titular</h3>
                <div class="flex-row">

                    <div class="col-xs-12">
                        <input-simulador
                            input-type="price"
                            @input="salvarTitular"
                            label="Rendimento mensal:"
                            v-model="fonteRendaTitular.rendimento_mensal"
                        />
                    </div>

                    <div class="col-lg-4 col-xs-12">
                        <label>Regime de Contratação:</label>
                    </div>

                    <div class="col-lg-8 col-xs-12">
                        <checkbox-input
                            :checkboxId  ="'clt-titular'"
                            :fieldStep   ="0.01"
                            :inputType   ="'checkbox_input'"
                            :label       ="'CLT'"
                            :valorMaximo="100 - fonteRendaTitular.autonomo - fonteRendaTitular.funcionario_publico"
                            :valorMinimo ="0"
                            @input       ="salvarTitular"
                            v-model      ="fonteRendaTitular.clt"
                        />

                        <checkbox-input
                            :checkboxId  ="'autonomo-titular'"
                            :fieldStep   ="0.01"
                            :inputType   ="'checkbox_input'"
                            label       ="Autônomo ou Liberal"
                            :valorMaximo="100 - fonteRendaTitular.funcionario_publico - fonteRendaTitular.clt"
                            :valorMinimo ="0"
                            @input       ="salvarTitular"
                            v-model      ="fonteRendaTitular.autonomo"
                        />



                        <checkbox-input
                            :checkboxId  ="'fp-titular'"
                            :fieldStep   ="0.01"
                            :inputType   ="'checkbox_input'"
                            label       ="Funcionário Público"
                           :valorMaximo="100 - fonteRendaTitular.autonomo - fonteRendaTitular.clt"
                            :valorMinimo ="0"
                            @input       ="salvarTitular"
                            v-model      ="fonteRendaTitular.funcionario_publico"
                        />
                    </div>
                </div>

                <div class="flex-row mt-6">
                    <div class="col-lg-4 col-xs-12">
                        <label for="checkboxes">Declaração IR:</label>
                    </div>
                    <div id="checkboxes" class="col-lg-4 col-xs-12">

                        <checkbox-input
                            inputType  ="radio_select"
                            name        ="declaracao_ir_titular"
                            checkboxId ="titular"
                            :opcoes     ="opcoes"
                            v-model     ="fonteRendaTitular.declaracao_ir"
                            @input      ="salvarTitular"
                        />
                    </div>
                    <div class="col-lg-4 col-xs-12 mt-2" v-if="fonteRendaTitular.declaracao_ir">
                        <router-link id="btn-simular-ir" class="btn btn-default with-ball" :to="rotaIR" :class="{'active' : cliente.contribuicao_previdencia_privada}">
                            <span>Simular IR</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-lg-offset-1 col-sm-12" v-if="fonteRendaConjuge">

                <h3 class="simulator-title subtitle">Cônjuge</h3>

                <div class="flex-row">

                    <div class="col-xs-12">
                        <input-simulador
                            input-type="price"
                            @input  ="salvarConjuge"
                            label   ="Rendimento mensal: "
                            v-model ="fonteRendaConjuge.rendimento_mensal"
                        />
                    </div>

                    <div class="col-lg-4 col-xs-12">
                        <label>Regime de Contratação:</label>
                    </div>

                    <div class="col-lg-8 col-xs-12">
                        <checkbox-input
                            :checkboxId  ="'clt-conjuge'"
                            :fieldStep   ="0.01"
                            :inputType   ="'checkbox_input'"
                            :label       ="'CLT'"
                            :valorMaximo ="100 - fonteRendaConjuge.funcionario_publico - fonteRendaConjuge.autonomo"
                            :valorMinimo ="0"
                            @input       ="salvarConjuge"
                            v-model      ="fonteRendaConjuge.clt"
                        />

                        <checkbox-input
                            :checkboxId  ="'autonomo-conjuge'"
                            :fieldStep   ="0.01"
                            :inputType   ="'checkbox_input'"
                            label        = "Autônomo ou Liberal"
                            :valorMaximo ="100 - fonteRendaConjuge.clt - fonteRendaConjuge.funcionario_publico"
                            :valorMinimo ="0"
                            @input       ="salvarConjuge"
                            v-model      ="fonteRendaConjuge.autonomo"
                        />

                        <checkbox-input
                            :checkboxId  ="'fp-conjuge'"
                            :fieldStep   ="0.01"
                            :inputType   ="'checkbox_input'"
                            label       ="Funcionário Público"
                            :valorMaximo ="100 - fonteRendaConjuge.clt - fonteRendaConjuge.autonomo"
                            :valorMinimo ="0"
                            @input       ="salvarConjuge"
                            v-model      ="fonteRendaConjuge.funcionario_publico"
                        />
                    </div>
                </div>

                <div class ="flex-row mt-6">
                    <div class ="col-lg-4 col-xs-12">
                        <label for ="checkboxes">Declaração IR: </label>
                    </div>
                    <div id="checkboxes" class="col-lg-6 col-sm-12">
                        <checkbox-input
                            inputType  ="radio_select"
                            name        ="declaracao_ir_conjuge"
                            checkboxId ="conjuge_ir"
                            :opcoes     ="opcoes"
                            v-model     ="fonteRendaConjuge.declaracao_ir"
                            @input      ="salvarConjuge"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="section ">
            <div class="flex-row middle-xs">
                <strong class="col-xs-6">TOTAL: </strong>
                <strong class="col-xs-6 end-xs">{{ soma | dinheiro }}</strong>
            </div>
        </div>
    </div>
</template>

<script>

import "@/../static/assets/css/custom/flex.css";
import {api} from "@/helpers/api";
import {debounce, isNull} from "lodash";

import CheckboxInput  from '@/components/common/CheckboxInput.vue';
import InputSimulador from '@/components/common/InputSimulador.vue';
import SvgPercentage  from '@/components/common/svg/SvgPercentage.vue';

export default {
    name: "seguro",

    components: {CheckboxInput, InputSimulador, SvgPercentage},

    data() {

        const id = parseInt(this.$route.params.id);

        return {
            cliente         : null,
            carregando      : false,

            opcoes          : [
                { nome: 'Simplificada', valor: 'S'},
                { nome: 'Completa',     valor: 'C'},
            ],

            fonteRendaTitular: null,
            fonteRendaConjuge: null,
        }
    },

    async created() {

        const {id} = this.$route.params;

        const {data: {result: {data: cliente}}} = await api.get(`cliente/${id}`);


        const fonteRendaTitular = {
            clt: null,
            autonomo: null,
            funcionario_publico: null,
            ...cliente.fontes_renda.find(item => item.tipo === 'T'),
            tipo: 'T',
            cliente_id: cliente.cliente_id,

        };

        if (cliente.contribuicao_previdencia_privada && !fonteRendaTitular.declaracao_ir) {
            fonteRendaTitular.declaracao_ir = (cliente.contribuicao_previdencia_privada.tipo === 'P') ? 'C' : 'S'

        }

        this.fonteRendaConjuge = {
            clt: null,
            autonomo: null,
            funcionario_publico: null,
            ...cliente.fontes_renda.find(item => item.tipo === 'C'),
            tipo: 'C',
            cliente_id: cliente.cliente_id,
        };



        this.fonteRendaTitular = fonteRendaTitular;

        this.cliente = cliente;
    },

    methods: {

        validar(fonteRenda) {

            const porcentagem_preenchida = ['clt', 'autonomo', 'funcionario_publico'].some(key => fonteRenda[key] !== null);

            return fonteRenda.fonte_renda_id || fonteRenda.rendimento_mensal || porcentagem_preenchida;

        },

        salvarTitular() { return this.salvar(this.fonteRendaTitular) },

        salvarConjuge() { return this.salvar(this.fonteRendaConjuge) },

        salvar: debounce(async function(fonteRenda) {

            if (! this.validar(fonteRenda)) return;

            this.carregando = true;


            if (fonteRenda.tipo === 'T' && this.cliente.contribuicao_previdencia_privada) {

                this.cliente.contribuicao_previdencia_privada.tipo = (fonteRenda.declaracao_ir == 'C') ? 'P' : 'V'

                api.put('contribuicao-previdencia-privada', this.cliente.contribuicao_previdencia_privada)
            }

            api.put('fonte-renda', fonteRenda).finally(
                setTimeout(() => this.carregando = false, 1500)
            ).catch(({response: {data, status}}) => {

                if (status === 422 && data.errors.soma_porcentagem_renda) {

                    Object.assign(fonteRenda, {
                        ...fonteRenda,
                        clt: null,
                        funcionario_publico: null,
                        autonomo: null
                    });
                }
            })



        }, 250),
    },

    computed: {
        soma() {

            if (!this.fonteRendaTitular || !this.fonteRendaConjuge) return;

            let valorTitular = () => (
                isNaN(this.fonteRendaTitular.rendimento_mensal) || isNull(this.fonteRendaTitular.rendimento_mensal)
                    ? 0
                    : parseFloat(this.fonteRendaTitular.rendimento_mensal
                )
            );

            let valorConjuge = () => (
                isNaN(this.fonteRendaConjuge.rendimento_mensal) || isNull(this.fonteRendaConjuge.rendimento_mensal)
                    ? 0
                    : parseFloat(this.fonteRendaConjuge.rendimento_mensal
                )
            );

            return valorTitular() + valorConjuge();
        },

        rotaIR(){

             if (!this.fonteRendaTitular) return;

            const name = this.fonteRendaTitular.declaracao_ir == 'C' ? 'cliente_contribuicao_previdencia_pgbl' : 'cliente_contribuicao_previdencia_vgbl';

            return {name, params: this.$route.params}
        },


        valorMaximoTitular()
        {
            var total = ['autonomo', 'funcionario_publico', 'clt'].reduce((soma, key) => {
                const num = parseFloat(this.fonteRendaTitular[key]);

                if (isNaN(num)) return soma;

                return soma + num;

            }, 0);

            return 100 - total;
        }
    },


    watch: {
        carregando(carregando) {
            this.$emit('update:carregando', carregando);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/simulador.scss';

.btn{
    position: relative;
    display: inline-flex;
    white-space: nowrap;
    align-items: center;

    &.with-ball::after{
        content: '';
        display: block;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        margin-left: 5px;
        background-color: #fff;
    }

    &:not(.active)::after{
        animation: pulse 500ms infinite alternate;
    }

     &.active::after{
        background-color: orange;
    }


}

#btn-simular-ir{
    padding: 0 10px;
}

@keyframes pulse{
    to{
        box-shadow: 0 0 0 15px rgba(#fff, .15);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/clientes/FonteDeRenda.vue